import React, { useEffect, useState } from "react";
import TimeCompo from "./TimeCompo";
import Setting from "./Setting";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ActivityLog from "./ActivityLog";
import { Link } from "react-router-dom";
import logo from "../components/img/logo.jpeg";
import { LogOut } from "react-feather";
import { handleSessionExpiry } from "../utils/sessionManager";
import SessionTimer from "../compo/SessionTimer";


export default function Navbar() {
  const [orgs, setOrgs] = useState([]);
  const [selectedOrgName, setSelectedOrgName] = useState("Organization");
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(false); // 👈 add state

  const navigate = useNavigate();


  useEffect(() => {
  handleSessionExpiry(navigate);
}, []);


 

  useEffect(() => {
    const adminId = localStorage.getItem("adminID");
    if (!adminId) {
      navigate("/"); 
    }

    // 👇 load dark mode preference
    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);
  }, [navigate]);

  // 👇 handle dark mode toggle
  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      document.body.classList.toggle("dark", newMode);
      localStorage.setItem("darkMode", newMode);

      setTimeout(() => {
      window.location.reload();
    }, 50);

    
      return newMode;
    });
  };

  useEffect(() => {
    const adminId = localStorage.getItem("adminID");
    if (!adminId) {
      navigate("/"); // Redirect to home if not logged in
    }
  }, [navigate]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("adminID");
        Swal.fire({
          icon: "success",
          title: "Logged out!",
          text: "You have been logged out successfully.",
          timer: 1500,
          showConfirmButton: false,
        });
        navigate("/");
      }
    });
  };

  useEffect(() => {
    // Check if switching org
    const isSwitching = localStorage.getItem("org_switching");

    if (isSwitching === "true") {
      setLoading(true);
      setTimeout(() => {
        localStorage.removeItem("org_switching");
        setLoading(false);
        window.location.reload(); // Continue the reload
      }, 1000);
      return;
    }

    const defaultId = localStorage.getItem("default");
    const defaultName = localStorage.getItem("organization_name");
    const otherOrgs = JSON.parse(localStorage.getItem("other_org")) || [];

    const allOrgs = [
      { id: defaultId, name: defaultName, isDefault: true },
      ...otherOrgs.map((org) => ({ ...org, isDefault: false })),
    ];

    setOrgs(allOrgs);
    setSelectedOrgName(defaultName || "Organization");
  }, []);

  const handleOrgChange = (selectedOrg) => {
    const defaultId = localStorage.getItem("default");
    const defaultName = localStorage.getItem("organization_name");
    let otherOrgs = JSON.parse(localStorage.getItem("other_org")) || [];

    if (selectedOrg.id !== defaultId) {
      const newDefault = selectedOrg;
      const newOtherOrgs = [
        { id: defaultId, name: defaultName },
        ...otherOrgs.filter((org) => org.id !== selectedOrg.id),
      ];

      localStorage.setItem("organization_id", newDefault.id);
      localStorage.setItem("default", newDefault.id);
      localStorage.setItem("organization_name", newDefault.name);
      localStorage.setItem("other_org", JSON.stringify(newOtherOrgs));
      localStorage.setItem("org_switching", "true"); // 🟡 mark switching

      window.location.reload();
    }
  };

  useEffect(() => {
    const isSwitching = localStorage.getItem("org_switching");

    if (isSwitching === "true") {
      setLoading(true);
      setTimeout(() => {
        localStorage.removeItem("org_switching");
        setLoading(false);
        window.location.reload(); 
      }, 1000);
      return;
    }

    const defaultId = localStorage.getItem("default");
    const defaultName = localStorage.getItem("organization_name");
    const otherOrgs = JSON.parse(localStorage.getItem("other_org")) || [];

    const allOrgs = [
      { id: defaultId, name: defaultName, isDefault: true },
      ...otherOrgs.map((org) => ({ ...org, isDefault: false })),
    ];

    setOrgs(allOrgs);
    setSelectedOrgName(defaultName || "Organization");
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <div className="fw-bold">Loading data...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`container-fluid py-2 d-flex 
        justify-content-between align-items-center shadow-sm 
        new-bg ${darkMode ? "dark" : ""}`}>

        {/* Left: Org Name Dropdown */}
        <div className="d-flex align-items-center gap-3">
          <h4 className={`fw-bold mb-0 mainttl ${darkMode ? "dark" : ""}`}>
            <img src={logo} className="img-fluid logo"/>
          </h4>
          <div className="dropdown">
            <button
              className="btn btn-outline-secondary dropdown-toggle px-3 py-2"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedOrgName}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {orgs.map((org, idx) => (
                <li key={idx}>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handleOrgChange(org)}
                  >
                    {org.name} {org.isDefault ? "(Current)" : ""}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Center: Time */}
        <TimeCompo />

        {/* Right: Settings + Mode Toggle */}
        <div className="d-flex gap-2 align-items-center">
          <button 
            onClick={toggleDarkMode} 
            className={`btn   btn-sm lghtbtn ${darkMode ? "dark" : ""}`}
          >
            {darkMode ? "🌙 Darkmode" : "☀️ Lightmode"}
          </button> 

<span className={`btn new-project-btn d-flex align-items-center gap-1 
        px-3 py-2 tab4 mainttl ${darkMode ? "dark" : ""} `} onClick={handleLogout}>
       <LogOut/> Logout
       </span>



        </div>
      </div>


 <SessionTimer/>


    </>
  );
}
